export let moreButtonLabel = "ZNGkyd";
export let feedbackButtonMenuLabel = "oO33Xc";
export let diagnosticsButtonMenuLabel = "vZp9$b";
export let featureFlagsButtonMenuLabel = "iFSmvc";
export let settingsButtonMenuLabel = "M3FmNd";
export let helpButtonMenuLabel = "UEC3Bd";
export default {moreButtonLabel,feedbackButtonMenuLabel,diagnosticsButtonMenuLabel,featureFlagsButtonMenuLabel,settingsButtonMenuLabel,helpButtonMenuLabel};